<template src="./WeatherStation.html"> </template>
<script>
import { mapState, mapActions } from 'vuex';

import WeatherStationList from './WeatherStationList/WeatherStationList.vue';
import SocialNotLoggedIn from '@/modules/Social/NotLoggedIn/NotLoggedIn.vue';

export default {
    name: 'WeatherStation',
    components: {
        WeatherStationList,
        SocialNotLoggedIn
    },
    data() {
        return {
            
        }
    },
    computed: {
        ...mapState({
            user: state => state.social.user
        }),
    },
    methods: {
        ...mapActions({
            getStations: 'getStations',
            addMapLayer: 'addMapLayer',

            setViewWeatherStationManager: 'setViewWeatherStationManager',

            setDataAnalysisFullScreen: 'setDataAnalysisFullScreen',

            setViewNotificationsManager: 'setViewNotificationsManager',
            // Ensure WS markers are hidden and creation state reset
            setWsLayerStatus: 'setWsLayerStatus',
            resetWsCreating: 'resetWsCreating',
        }),

        onCloseWs() {
            this.setDataAnalysisFullScreen(false);
            this.setViewWeatherStationManager(false);
            this.setViewNotificationsManager(false);
            this.addMapLayer([]);

            // Remove WS markers and any in-progress creation marker from the map
            this.setWsLayerStatus(true);
            this.resetWsCreating();
        }
    },
    mounted() {
        this.getStations();
    },
}
</script>

<style lang="scss" src="./WeatherStation.scss"></style>